import parseNavigation from './parseNavigation';

/** Menú del rol gestor: `tipo id | título | ícono | url`, anidado por tabulación. */
const managerNavigation = parseNavigation(`
group manager | Registro de material | account_tree
	item register | Registrar entrega | local_shipping | /manager/register
group manager-certificates | Certificados | account_tree
	item manager-certificate-avaibles | Certificados disponibles | check_circle_outline | /certificates/manager/avaibles
	item manager-certificate-nominees | Certificados nominados | person_pin | /certificates/manager/nominees
	item manager-circularity-available | Certificados de circularidad disponibles | recycling | /circularity/available
	item manager-circularity-nominations | Certificados de circularidad nominados | how_to_reg | /circularity/consult/nominations
group manager-consults | Consultas | account_tree
	item manager-delivered-material-info | Entrega de material | local_shipping | /manager/consults/delivered/material-info
	item manager-invoiced-info | Facturación de material | receipt | /manager/consults/invoiced-info
	item manager-received-transfer-info | Certificados recibidos | move_to_inbox | /manager/consults/received/transfer-info
	item manager-send-transfer-info | Certificados transferidos | send | /manager/consults/send/transfer-info
	item manager-circularity-received | Certificados de circularidad recibidos | move_to_inbox | /circularity/consult/received-transfer
	item manager-circularity-sent | Certificados de circularidad transferidos | send | /circularity/consult/sent-transfer
`);

export default managerNavigation;
